export default "\n<router-outlet>    \n\n</router-outlet>\n\n\n"